export default "__VITE_ASSET__e4a114f8__"